import { Flex, BackgroundImage } from '@mantine/core';
import classes from './layout.module.scss';
import { Outlet } from 'react-router';

export const Layout = () => {
  return (
    <Flex className={classes.container}>
      <BackgroundImage src='/authBg.webp' className={classes.bgImg} />

      <Flex className={classes.formContainer}>
        <Outlet />
      </Flex>
    </Flex>
  );
};
